export const selectCredentials = () => {
    const giftlyToken = localStorage.getItem('giftly-extension-token');
    const credentials = {
        extensionToken: giftlyToken || null
    };
    return giftlyToken ? credentials : {};
};
